import { createAsyncThunk, createSlice, } from "@reduxjs/toolkit";
// import axios from "axios";

const MOCK_ADDRESSES_KEY = 'mock_addresses';

const getMockAddresses = () => {
  const addresses = localStorage.getItem(MOCK_ADDRESSES_KEY);
  return addresses ? JSON.parse(addresses) : {};
};

const saveMockAddresses = (addresses) => {
  localStorage.setItem(MOCK_ADDRESSES_KEY, JSON.stringify(addresses));
};

export const getUserAddress = createAsyncThunk('address/getUserAddress', async ({ user }, { rejectWithValue }) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        const allAddresses = getMockAddresses();
        const userAddresses = allAddresses[user] || [];
        resolve(userAddresses);
      }, 300);
    });
  } catch (err) {
    return rejectWithValue(err)
  }
}
)

export const createAddress = createAsyncThunk('address/createAddress', async (addressData, { getState, rejectWithValue }) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        const allAddresses = getMockAddresses();
        const userAddresses = allAddresses[addressData.user] || [];
        
        const newAddress = {
          ...addressData,
          _id: Date.now().toString(),
          createdAt: new Date().toISOString()
        };
        
        userAddresses.push(newAddress);
        allAddresses[addressData.user] = userAddresses;
        saveMockAddresses(allAddresses);
        
        resolve(userAddresses);
      }, 300);
    });
  } catch (err) {
    return rejectWithValue(err)
  }
}
)

export const deleteAddress = createAsyncThunk('address/deleteAddress', async ({ address, user }, { getState, rejectWithValue }) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        const allAddresses = getMockAddresses();
        const userAddresses = allAddresses[user] || [];
        
        const filtered = userAddresses.filter(addr => addr._id !== address);
        allAddresses[user] = filtered;
        saveMockAddresses(allAddresses);
        
        resolve(filtered);
      }, 300);
    });
  } catch (err) {
    return rejectWithValue(err)
  }
}
)

export const updateAddress = createAsyncThunk('address/updateAddress', async (addressInfo, { getState, rejectWithValue }) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        const allAddresses = getMockAddresses();
        const userAddresses = allAddresses[addressInfo.user] || [];
        
        const index = userAddresses.findIndex(addr => addr._id === addressInfo._id);
        if (index !== -1) {
          userAddresses[index] = { ...userAddresses[index], ...addressInfo };
        }
        
        allAddresses[addressInfo.user] = userAddresses;
        saveMockAddresses(allAddresses);
        
        resolve(userAddresses);
      }, 300);
    });
  } catch (err) {
    return rejectWithValue(err)
  }
}
)

export const setDefaultAddress = createAsyncThunk('address/setDefaultAddress', async (addressInfo, { getState, rejectWithValue }) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        const allAddresses = getMockAddresses();
        const userAddresses = allAddresses[addressInfo.user] || [];
        
        // Set all to non-default
        userAddresses.forEach(addr => addr.isDefault = false);
        
        // Set selected as default
        const index = userAddresses.findIndex(addr => addr._id === addressInfo.id);
        if (index !== -1) {
          userAddresses[index].isDefault = true;
        }
        
        allAddresses[addressInfo.user] = userAddresses;
        saveMockAddresses(allAddresses);
        
        resolve(userAddresses);
      }, 300);
    });
  } catch (err) {
    return rejectWithValue(err)
  }
}
)

const addressSlice = createSlice({
  name: "address",
  initialState: {
    loading: false,
    error: false,
    success: false,
    errMsg: '',
    addresses: [],
    showAddressForm: false,
    deleting: false,
    updateForm: false,
    addressIndex: null,
    settingDefault: false
  },
  reducers: {
    addressFormDisplay: (state, action) => {
      state.showAddressForm = true
      state.success = false
    },
    hideAddressForm: (state, action) => {
      state.showAddressForm = false
      state.updateForm = false
      state.addressIndex = null
    },
    updateFormDisplay: (state, action) => {
      state.updateForm = true
      state.showAddressForm = false
      state.success = false

      // TO GET THE INDEX OF THE CLICKED ADDRESS YOU WANT TO UPDATE
      state.addressIndex = action.payload.addressIndex
    }
  },
  extraReducers: {
    [getUserAddress.pending]: (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [getUserAddress.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.addresses = payload
      state.errorMsg = ''
      state.showAddressForm = false
      state.success = true
    },
    [getUserAddress.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errorMsg = payload
      state.success = false
    },
    [createAddress.pending]: (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [createAddress.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.addresses = payload
      state.errorMsg = ''
      state.showAddressForm = false
      state.success = true
    },
    [createAddress.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errorMsg = payload.msg ? payload.msg : payload
      state.success = false
    },
    [deleteAddress.pending]: (state) => {
      state.loading = true
      state.error = false
      state.deleting = true
      state.success = false
    },
    [deleteAddress.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.addresses = payload
      state.errorMsg = ''
      state.showAddressForm = false
      state.deleting = false
      state.success = true
    },
    [deleteAddress.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errorMsg = payload.msg ? payload.msg : payload
      state.deleting = false
      state.success = false
    },
    [updateAddress.pending]: (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [updateAddress.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.addresses = payload
      state.errorMsg = ''
      state.updateForm = false
      state.success = true
    },
    [updateAddress.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errorMsg = payload
      state.success = false
    },
    [setDefaultAddress.pending]: (state) => {
      state.loading = true
      state.error = false
      state.settingDefault = true
    },
    [setDefaultAddress.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.addresses = payload
      state.errorMsg = ''
      state.updateForm = false
      state.settingDefault = false
    },
    [setDefaultAddress.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errorMsg = payload
      state.settingDefault = false
    },
  }
})


export const { addressFormDisplay, hideAddressForm, updateFormDisplay } = addressSlice.actions;
export default addressSlice.reducer